export const generateRebuzzUIDKey = ({ anchorItemId, streamItemId }) => {
  if (anchorItemId) {
    return `thread/${anchorItemId}/${streamItemId}`;
  }

  return streamItemId;
};
